export const LINE_LIFF_ID = import.meta.env.VITE_LIFF_ID as string;
export const API_BASE_URL = import.meta.env.VITE_API_BACKEND as string;